<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Italian Prince, Wedlocked Wife</title>
<link href="pdlmsr.css" rel="stylesheet" type="text/css"/>
<meta content="text/html; charset=UTF-8"/>
<div class="titlePage" id="tp01"><h2 class="titlePageAuthor"><em class="italic"><span>Jennie Lucas</span></em></h2><h2 class="titlePageTitle">ITALIAN PRINCE, WEDLOCKED WIFE</h2><p class="titlePageText"><span><img alt="image" src="Images/3.jpg"/></span></p><p class="titlePageLogo"><span><img alt="image" src="Images/logo.jpg"/></span></p><p class="titlePageCity"><span><span class="smallCaps"><span>TORONTO • NEW YORK • LONDON<br/>
AMSTERDAM • PARIS • SYDNEY • HAMBURG<br/>
STOCKHOLM • ATHENS • TOKYO • MILAN • MADRID<br/>
PRAGUE • WARSAW • BUDAPEST • AUCKLAND</span></span></span></p></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// italianprincewedlockedwife_tp01.vue?4822cc52